<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title" :title1="title1" />
        <!-- /add -->
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Department Name</label>
                  <b-form-input type="text"  v-model="form.deptname" ref='firstInput' @keypress.enter="submitForm()"/>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Department Head</label>
                  <b-form-input type="text"  v-model="form.depthead" @keypress.enter="submitForm()"/>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Email</label>
                  <b-form-input type="text"  v-model="form.email" @keypress.enter="submitForm()"/>
                </div>
              </div>
              <div class="col-lg-9 col-12">
                <div class="form-group">
                  <label>Phone</label>
                  <b-form-input type="text"  v-model="form.phone" @keypress.enter="submitForm()"/>
                </div>
              </div>
              <div class="col-lg-12">
                <a v-on:click="postData()" class="btn btn-submit me-2">Submit</a>
                <router-link to="customerlist" class="btn btn-cancel">Cancel</router-link>
              </div>
            </div>
          </div>
        </div>
        <!-- /add -->
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { mapGetters } from "vuex";
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.post['Content-Type'] ='application/json;charset=utf-8';
export default {

  computed: {
    ...mapGetters([
      "getCurrentLocationId",
    ]),

    locationId() {
      return this.getCurrentLocationId;
    }
  },
  data() {
    return {
      form: {
        deptname: '',
        depthead: '',
        email: '',
        phone:'',
        locationid:'',
      },
      title: "Department Management",
      title1: "Add Department",
    };
  },
  methods: {
    async postData() {
      if (!this.form.deptname) {
        Swal.fire("Please enter the department name");
        return;
      }
      this.form.locationid = this.locationId
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: "Do you really want to submit the form?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, submit it!'
      });

      if (result.isConfirmed) {
      axios
      .post('/v1/departments', this.form)
      .then(response => {
        //this.res = "Status " + response.status + ". Category created";
        Swal.fire("Department created successfully");
        this.$router.push({ path: '/customerlist' });
      })
      .catch(error => {
        console.log(error)
        Swal.fire(error.response.data.detail);
      });
      }
    },
    submitForm() {
      this.postData();
    }
  },
  mounted(){
    this.$refs.firstInput.focus();
  },
  name: "addcustomer",
};
</script>
